import Axios from "axios"
import { CMSPath_Master } from "../config/constant"

const base_url_gha = Axios.create({ baseURL: `${CMSPath_Master}/RewardsApiApp/rest` })

export const GHAwelcomePagefetchHTML = async () => {
    try {
         
        const data = await Axios.get(`${CMSPath_Master}/Connector/rest/assets?type=rewardsProgramHtml&languageCode=en`);
        console.log("api WELCOME PAGE HTML RESPONSE", data.data)
        return data.data;
        

    } catch (err) {
        //sendanalytics
        throw new Error(err);
    
    }
}


export const fetchAvailableLanguages = async () => {


    try {
        const res = await base_url_gha.get("/lov?type=language",
            { headers: { "Authorization": `Bearer ${localStorage.getItem("GuestJourneyMasterConnectorSessionToken")}` } });
        return res;
    }
    catch (err) {
        throw new Error((err.response))
    }

}


export const enrollGhaUser = async (payload) => {
    try {
        const res = await base_url_gha.post("/enroll",
            { payload },
            { headers: { "Authorization": `Bearer ${localStorage.getItem("GuestJourneyMasterConnectorSessionToken")}` } });
        return res;
    }
    catch (err) {
        if (err.response)
            throw new Error(err.response && err.response.data && err.response.data.payload && err.response.data.payload.errorMsg)
        else throw new Error("")
    }

}


export const loginGhaUser = async (payload) => {
    try {
        const res = await base_url_gha.post("/login",
            { payload },
            { headers: { "Authorization": `Bearer ${localStorage.getItem("GuestJourneyMasterConnectorSessionToken")}` } });
        return res;
    }
    catch (err) {
        // throw new Error();
        return (err)
    }

}


export const getGhaPasswordReset = async (payload) => {
    try {
        const res = await base_url_gha.post("/forgotPassword",
            { payload },
            { headers: { "Authorization": `Bearer ${localStorage.getItem("GuestJourneyMasterConnectorSessionToken")}` } });
        return res;
    }
    catch (err) {
        throw new Error()
    }

}

export const getGhaProfileInfo = async (payload) => {
    try {
        const res = await base_url_gha.post("/profile",
            { payload },
            { headers: { "Authorization": `Bearer ${localStorage.getItem("GuestJourneyMasterConnectorSessionToken")}` } });
        return res;
    }
    catch (err) {
        throw new Error()
    }

}